import { ActionTree, MutationTree, GetterTree } from 'vuex'
import { FAVOURITES } from '~/assets/config/api-path'
import { IStateIndex } from '~/store/index'
import { IFavouriteItem } from '~/assets/interfaces/favourites'
import { filterUrl } from '~/assets/filters/url'
import { analyticsReachGoal } from '~/assets/functions/analytics'
import { runIdle } from '~/assets/functions/runIndle'

interface IState {
  items: IFavouriteItem[]
  isLoading: boolean
  isFirstLoaded: boolean
}

export const state = (): IState => ({
  items: [],
  isLoading: false,
  isFirstLoaded: false,
})

export const mutations: MutationTree<IState> = {
  setItems(state: IState, val: IFavouriteItem[]) {
    state.items = val
  },
  setLoading(state: IState, val: boolean) {
    state.isLoading = val
  },
  setFirstLoaded(state: IState, val: boolean) {
    state.isFirstLoaded = val
  },
}

export const getters: GetterTree<IState, IStateIndex> = {
  itemsQuantity(state: IState): number {
    return state.items.length
  },
}

export const actions: ActionTree<IState, IStateIndex> = {
  async getItems({ commit }) {
    commit('setLoading', true)
    const response = await this.$axios.$get(filterUrl(FAVOURITES))
    runIdle(() => {
      commit('setItems', response.items || [])
      commit('setLoading', false)
      commit('setFirstLoaded', true)
    })
  },
  async toFavourites({ dispatch, commit }, payload): Promise<void> {
    commit('setLoading', true)
    const toFavourites = async () => {
      await this.$axios.$post(filterUrl(FAVOURITES), {
        id: payload.id,
      })
      analyticsReachGoal('goal_product_toFavourites ')
    }

    await dispatch('getItems', await toFavourites())
    commit('setLoading', false)
  },
}
